<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      收货信息
    </div>
    <div class="rj-page-card__content">
      <Collapse :open="true">
        <div slot="header">
          <span>配送至：</span>
          <!-- <span>{{ address }}</span> -->
          <div v-if="address" class="adressBox">
            <div v-if="address.isDefault" class="defTab">
              默认
            </div>
            <div class="item">
              {{ address.receiverName }}
            </div>
            <div class="item">
              {{ address.province }}
            </div>
            <div class="item">
              {{ address.city }}
            </div>
            <div class="item">
              {{ address.county }}
            </div>
            <div class="item">
              {{ address.receiptAddress }}
            </div>
            <div class="item">
              {{ address.receiverPhone }}
            </div>
          </div>
          <el-button v-if="address && address.receiverName" type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            更改地址
          </el-button>
          <el-button v-else type="text" style="padding: 0;margin-left: 15px" @click.stop="showAddress=true">
            选择地址
          </el-button>
        </div>
        <p v-if="form.blackBoardProduct" style="margin-left:10px;color:red">
          【极其重要】智慧黑板RG-IIB-N86A下单要求：
          代理商下单过程请务必提供给平台商务「设备实际需要安装的地址」，且按照实际地址发货，否则新增地址上游供应商不予以上门安装，如有疑问请联系对应平台商务。
        </p>
        <p v-if="form.flatProduct" style="margin-left:10px;color:red">
          【极其重要】交互式智能平板（RG-IIB-K大屏）下单后的存储要求：
          因AG玻璃特性决定大屏存储期限只有3个月左右，如无法在收货后3个月内完成部署安装，因环境影响可能低概率出现玻璃水雾或霉变，此类情况非产品品质问题，若出现不支持退换，请联系400安排维修。
        </p>
        <slot name="freightInfo" />
        <div style="padding: 20px">
          <p v-if="CustomizationList.length" style="padding: 10px 0;color: red">
            此单涉及定制化产品，具体型号为：
            <el-tag v-for="(item,index) in CustomizationList" :key="index">
              {{ item.productName }}
            </el-tag>
            下单时请代理商支付此合同全部货款的30%进行下单，有疑问，请联系对应销售。
          </p>
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker v-model="allAttribute.time" type="date" value-format="yyyy-MM-dd" placeholder="选择期望发货日期" />
            </el-form-item>
            <el-form-item>
              <el-select v-model="allAttribute.freight" placeholder="请选择货运属性">
                <el-option v-for="(value, key) in freightProperty" :key="key"
                           :label="value"
                           :value="key"
                />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="taxRate" placeholder="请选择税率">
                <el-option v-for="item in taxRateList" :key="item.dictLabel" :label="item.dictValue" :value="item.dictLabel" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="batchSettings">
                批量设置
              </el-button>
              <el-button type="default" @click="setMaterialNum()">
                设置料号
              </el-button>
              <el-button type="default" @click="addNewRow">
                添加产品行
              </el-button>
              <el-button type="default" @click="setSerialNum">
                批量设置冲销序列号
              </el-button>
              <el-button type="default" @click="batchDeatail">
                删除勾选产品行
              </el-button>
              <el-button type="default" @click="taxRateSettings">
                批量设置税率
              </el-button>
            </el-form-item>
            <p style="color:red;font-size:10px;margin-bottom:10px">
              注：1.若只冲样机借用，请点“批量设置冲销序列号”进行设置；2.若只冲销售借用，请自行拆行进行冲销；3.若同时冲样机借用和销售借用，请先点“批量设置冲销序列号”冲销完样机借用，再手工拆行冲销售借用。
              <span>{{ form.specialCloudDesc }}</span>
            </p>
          </el-form>
          <div class="table">
            <el-table :data="productList" border
                      style="width: 100%"
                      show-summary
                      :summary-method="getSummaries"
                      :row-class-name="tableRowClassName"
                      :height="tableHeight"
                      @selection-change="handleSelectionChange"
            >
              <el-table-column
                type="selection"
                width="55"
                align="left"
              />
              <el-table-column fixed type="index" width="50" label="序号" align="left" />
              <el-table-column fixed prop="productCode" label="销售代码" align="left" width="98" />
              <el-table-column fixed prop="productName" label="产品型号" align="left" width="200">
                <template v-slot="{row}">
                  <choose-product :row="row" :form="form" />
                </template>
              </el-table-column>
              <el-table-column fixed prop="productCode" label="料号" align="left" width="130">
                <template v-slot="{row,$index}">
                  <el-button type="text" :disabled="row.exclusiveMaterialNumber!=''&&row.exclusiveMaterialNumber!=null" @click="setMaterialNum(row,$index)">
                    {{ row.materialNumberId?row.materialNumberId:'选择料号' }}
                  </el-button>
                </template>
              </el-table-column>
              <el-table-column fixed prop="productNum" label="数量" align="left" width="80">
                <template v-slot="{row}">
                  <el-input-number v-model="row.productNum" :disabled="row.isBorrow" :min="0" :controls="false" style="width:100%;" @change="Recalculation()" />
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="单位" align="left" width="60" />
              <el-table-column prop="productPriceSigle" label="单价" align="right" header-align="left" width="100">
                <template v-slot="{row}">
                  <el-input-number v-model="row.productPriceSigle" :min="0" :controls="false" style="width:100%;" @change="Recalculation()" />
                </template>
              </el-table-column>
              <el-table-column prop="orderAmount" label="订单金额" align="right" header-align="left" width="100">
                <template v-slot="{row}">
                  {{ row.orderAmount }}
                </template>
              </el-table-column>
              <el-table-column prop="settlementAmount" label="实际结算金额" align="right" header-align="left" width="135">
                <template v-slot="{row}">
                  <el-input-number v-model="row.settlementAmount" :precision="6" :step="0.01" :min="0" :controls="false" style="width:100%;" />
                </template>
              </el-table-column>
              <el-table-column prop="isBorrow" label="测试借条转订单" align="left" width="60">
                <template v-slot="{row,$index}">
                  <el-checkbox v-model="row.isBorrow" :disabled="row.debitNum?true:false" @change="clickBorrow(row,$index)" />
                </template>
              </el-table-column>
              <el-table-column prop="debitNum" label="冲借销借用单号" align="left" width="150" />
              <el-table-column prop="expectedDeliveryDate" label="期望发货日期" align="left" width="140">
                <template v-slot="{row}">
                  <el-date-picker v-model="row.expectedDeliveryDate" type="date" style="width:100%;" value-format="yyyy-MM-dd" placeholder="期望发货日期" :clearable="false" />
                </template>
              </el-table-column>
              <el-table-column prop="beforeSplitProductPriceSigle" label="拆分前单价" align="right" header-align="left" width="100">
                <template v-slot="{row}">
                  <el-input-number v-if="row.addNew || (form && form.isNewContract)" v-model="row.beforeSplitProductPriceSigle" :min="0" :controls="false" style="width:100%;" />
                  <span v-else>{{ row.beforeSplitProductPriceSigle }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="pname" label="货运属性" align="left" width="130">
                <template v-slot="{row}">
                  <el-select v-model="row.freightProperty" placeholder="货运属性">
                    <el-option v-for="(value, key) in freightProperty" :key="key"
                               :label="value"
                               :value="key"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="pname" label="是否购买PSC" align="left" width="60">
                <template v-slot="{row}">
                  {{ row.isPsc?'是':'否' }}
                </template>
              </el-table-column>
              <el-table-column prop="productConfigInfo" label="产品配置描述" align="left" width="180" />
              <el-table-column v-if="form.manufactureRefurbished" prop="manufactureRefurbished" label="是否官翻机产品" align="left" width="180">
                <template v-slot="{row}">
                  {{ row.manufactureRefurbished?'是':'否' }}
                </template>
              </el-table-column>
              <el-table-column prop="serviceDesc" label="服务备注" align="left" width="120" />
              <el-table-column label="税率" align="right" header-align="left" width="100">
                <template v-slot="{row}">
                  <el-select v-model="row.rate" placeholder="请选择税率">
                    <el-option v-for="item in taxRateList" :key="item.dictLabel" :label="item.dictValue" :value="item.dictLabel" />
                  </el-select>
                </template>
              </el-table-column>
              <!-- <el-table-column v-if="form.abc" label="操作" align="left"> -->
              <!-- // 是否直签 false(非直签) true(直签) -->
              <el-table-column label="操作" align="left" fixed="right">
                <template v-slot="{row,$index}">
                  <el-button :disabled="row.isBorrow" type="text" style="padding: 0;" @click="copyRow(row,$index)">
                    <i class="el-icon-circle-plus-outline" style="font-size: 16px;" />
                  </el-button>
                  <el-button :disabled="row.isBorrow" type="text" style="padding: 0;color: #F56C6C" @click="removeProduct($index)">
                    <i class="el-icon-delete" style="font-size: 16px;" />
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </Collapse>
      <slot />
    </div>
    <address-box :prop-open.sync="showAddress" @chooseAddress="changeAddress" @ChangeDatas="ChangeDatas" />
    <set-serial :dialogvisible="dialogVisibleBool" :set-serial-data="setSerialData" @setSerialClose="setSerialClose" @getTableData="getTableData" />
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
  </div>
</template>
<script type="es6">
import Collapse from '@/components/Collapse';
import chooseProduct from '../../contractCommonInput/chooseProduct';
import MaterialNum from '../../contractCommonInput/MaterialNum';
import addressBox from '@/views/address/index.vue';
import setSerial from '../../contractCommonInput/setSerial';
import { mapState } from 'vuex';
import { MathMulti, MathAdd, numDiv, Subtr, DateToStr } from '@/libs/util';
import { getReceiptAddressInfoModel } from '@/API';
import { getDictData } from '@/API/international';
// import eventBus from '../../../libs/eventBus';
export default {
  data () {
    return {
      allAttribute: {
        time: '',
        freight: ''
      },
      productList: [],
      showAddress: false,
      loading: false,
      address: {},
      tableHeight: 400,
      dialogVisibleBool: false,
      multipleSelection: [],
      setSerialData: {},
      taxRate: '',
      taxRateList: []
      // pickerOptions: {
      //   disabledDate: (time) => {
      //     if (this.allAttribute.time) {
      //       return time.getTime() <= (new Date(this.allAttribute.time)).getTime();
      //     }
      //     return false;
      //   }
      // }
    };
  },
  props: {
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    isTestProject: {
      type: [Boolean, Number],
      default: false
    },
    contractId: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    form: {
      type: Object,
      default: () => { return {}; }
    }
  },
  components: {
    Collapse,
    addressBox,
    chooseProduct,
    MaterialNum,
    setSerial
  },
  computed: {
    // 定制化产品
    CustomizationList () {
      return this.productList.filter((item) => {
        return item.customizationOrNot;
      });
    },
    ...mapState({
      freightProperty: state => state.enumeration.freightProperty
    }),
    // 数量总计
    AmountTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.productNum) {
          cont = MathAdd(cont, item.productNum);
        }
      });
      return cont;
    },
    // 订单金额总计
    computePriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.orderAmount) {
          cont = MathAdd(item.orderAmount, cont);
        }
      });
      cont = Number(cont).toFixed(2);
      this.Recalculation();
      return cont;
    },
    // 实际结算金额总计
    settlementSumTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        if (item.settlementAmount) {
          cont = MathAdd(cont, item.settlementAmount);
        }
      });
      return cont;
    },
    // 拆分前单价总计
    beProductUnitPriceTotal () {
      let cont = 0;
      this.productList.forEach((item) => {
        let itemcont = MathMulti(item.productNum, item.beforeSplitProductPriceSigle);
        cont = MathAdd(itemcont, cont);
      });
      cont = Number(cont).toFixed(2);
      return cont;
    }
  },
  methods: {
    initData () {
    },
    taxRateFn () {
      let params = { dictType: 'tax_rate' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.taxRateList = data;
        }
      });
    },
    taxRateSettings () {
      // let error = '';
      if (this.taxRate) {
        this.productList.forEach((item) => {
          item.rate = this.taxRate;
        });
      }
    },
    // 批量删除
    batchDeatail () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请勾选需要删除产品行');
        return;
      }
      this.$confirm('是否删除勾选产品行?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        for (var i = 0; i < this.productList.length; i++) {
          for (var j = 0; j < this.multipleSelection.length; j++) {
            if (this.productList[i].itemIndex === this.multipleSelection[j].itemIndex) {
              this.productList.splice(i, 1);
            }
          }
        };
        this.multipleSelection = [];
      }).catch(() => {

      });
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    tableRowClassName ({ row }) {
      if (row.highlight === 1) {
        return 'red-row';
      } else {
        return '';
      }
    },
    batchSettings () {
      let error = '';
      this.productList.forEach((item) => {
        if (this.allAttribute.time) {
          let nowDateStr = DateToStr(new Date());
          if (new Date(this.allAttribute.time) >= new Date(nowDateStr)) {
            this.$set(item, 'expectedDeliveryDate', this.allAttribute.time);
          } else {
            error = '期望发货日期不能小于当前日期';
          }
        }
        if (this.allAttribute.freight) {
          this.$set(item, 'freightProperty', this.allAttribute.freight);
        }
        if (this.taxRate) {
        // this.productList.forEach((item) => {
        //   item.rate = this.taxRate;
        // });
          this.$set(item, 'rate', this.taxRate);
        }
      });
      if (error) {
        this.$notify.error({
          message: error
        });
      }
    },
    // 合计行的计算
    getSummaries (param) {
      // let allowsum = ['数量', '订单金额', '实际结算金额'];
      const { columns } = param;
      const sums = [];
      // 计算当前数据冲销合计
      let moneyTotal = 0;
      for (var i = 0; i < this.productList.length; i++) {
        if (this.productList[i].isBorrow) {
          moneyTotal = moneyTotal + this.productList[i].settlementAmount;
        }
      }
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = this.AmountTotal;
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = Number(this.computePriceTotal).toFixed(2);
          return;
        }
        if (column.label === '产品型号') {
          sums[index] = '冲销合计:' + moneyTotal + '元';
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = Math.round(this.settlementSumTotal * 100) / 100;

          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = Number(this.beProductUnitPriceTotal).toFixed(2);
        }
      });
      return sums;
    },
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.showAddress = false;
      this.$emit('chooseAddress', val);
    },
    ChangeDatas () {
      // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let json = res.data;
          if (json.status === '200') {
            if (!json.data.isDelete) {
              this.address = json.data;
            } else {
              this.address = {};
            }
          }
        }).catch(() => {

        });
      }
    },
    validate () {
      let error = '';
      if (!this.productList.length) {
        error = '请选择产品';
      }
      if (Number(this.beProductUnitPriceTotal) !== Number(this.computePriceTotal)) {
        error = '拆分前单价与订单金额不符';
      }
      this.productList.forEach((item) => {
        this.$delete(item, 'removeVisible');
        this.$delete(item, 'addNew');
        if (!error) {
          if (!item.productCode) {
            error = '存在产品未选产品型号';
          } else if (!item.materialNumberId) {
            error = '存在产品未选择期料号';
          } else if (!item.expectedDeliveryDate) {
            error = '存在产品未选择期望发货日期';
          } else if (!item.freightProperty) {
            error = '存在产品未选择货运属性';
          } else if (!item.rate) {
            error = '存在产品未选择税率';
          }
        }
      });
      return new Promise((resolve, reject) => {
        if (error) {
          this.$notify.error({
            message: error
          });
          resolve(false);
        } else {
          resolve({ productList: this.productList, actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2), orderSales: this.computePriceTotal });
        }
      });
    },
    validateDraft () {
      return new Promise((resolve, reject) => {
        resolve({ productList: this.productList, actualSettlementAmount: Number(this.settlementSumTotal).toFixed(2), orderSales: this.computePriceTotal });
      });
    },
    getOrderAmount (row) {
      let Amount = MathMulti(row.productNum, row.productPriceSigle);
      row.orderAmount = Number(Amount);
      this.getSettlementAmount(row);
      return row.orderAmount;
    },
    getSettlementAmount (row) {
      // 计算实际结算金额
      let rel = row.orderAmount;

      if (this.salesType === 1 && this.rebate !== 1 && this.isTestProject === false) {
        // 如果是现销 乘返点。
        rel = MathMulti(rel, this.rebate);
      }
      if (this.rebateAmount !== null && this.computePriceTotal) {
        let rd = numDiv(row.orderAmount, this.computePriceTotal); // 金额比例
        // console.log(rd, 'rd');
        // console.log(row.orderAmount, 'row.orderAmount');
        // console.log(this.computePriceTotal, 'this.computePriceTotal');
        let thisrd = this.rebateAmount * rd;
        rel = Subtr(rel, thisrd);
        // row.settlementAmount = 123;
        row.settlementAmount = Number(MathMulti(Number(rel), this.communicationOrderDiscount ? this.communicationOrderDiscount : 1));
        // console.log(row.settlementAmount, 'row.settlementAmount');
        return MathMulti(rel, this.communicationOrderDiscount === null ? 1 : this.communicationOrderDiscount);
      }
      row.settlementAmount = Number(MathMulti(Number(rel), this.communicationOrderDiscount ? this.communicationOrderDiscount : 1));
      // console.log(row.settlementAmount, 'row.settlementAmount');
      // row.settlementAmount = 123;
      return rel;
    },
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let list = this.productList;
        this.productList = [];
        this.$nextTick(() => {
          list.splice(index, 1);
          list.forEach((item) => {
            if (item.itemIndex > index) {
              item.itemIndex = item.itemIndex - 1;
            }
          });
          this.productList = list;
        });
      }).catch(() => {

      });
    },
    copyRow (row, index) {
      let newRow = JSON.parse(JSON.stringify(row));
      newRow.id = null;
      this.productList.splice(index + 1, 0, newRow);
      this.$nextTick(() => {
        for (let i = 0; i < this.productList.length; i++) {
          this.productList[i].itemIndex = i;
        }
      });
    },
    addNewRow () {
      this.productList.push({
        orderAmount: 0,
        settlementAmount: 0,
        materialNumberId: '',
        productNum: 0,
        productPriceSigle: 0,
        beforeSplitProductPriceSigle: 0,
        removeVisible: false,
        addNew: true
      });
    },
    // 设置序列号
    setSerialNum () {
      this.dialogVisibleBool = true;
      this.setSerialData = {
        'contractId': this.contractId,
        'getGoodsList': this.productList
      };
      // this.$notify.error({
      //   message: '设置冲销序列号'
      // });
    },
    setSerialClose (val) {
      this.dialogVisibleBool = val;
    },
    getTableData (val) {
      this.productList = val;
    },
    setMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({
          message: '请先选择订单分类'
        });
        return;
      }
      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      if (!row) {
        this.productList.forEach((item, index) => {
          console.log(this.$cloneDeep(item), item.materialNumberId, 1);
          if (item.productCode && !item.exclusiveMaterialNumber) {
            console.log(item.materialNumberId);
            productAndMaterialGroup.push({
              productSalesCode: item.productCode,
              productName: item.productName,
              exclusiveMaterial: item.materialNumberId || '',
              productNum: item.productNum,
              isHavePowerCord: item.isHavePowerCord || false,
              isTestOrder: item.isBorrow || false
            });
            MaterialNumValues[item.productCode] = {
              materialNumberId: item.materialNumberId,
              materialUnit: item.materialUnit
            };
          }
        });
      } else {
        if (row.productCode && !row.exclusiveMaterialNumber) {
          productAndMaterialGroup.push({
            productSalesCode: row.productCode,
            productName: row.productName,
            exclusiveMaterial: row.materialNumberId,
            productNum: row.productNum,
            isHavePowerCord: row.isHavePowerCord || false,
            isTestOrder: row.isBorrow || false
          });
          MaterialNumValues[row.productCode] = {
            materialNumberId: row.materialNumberId,
            materialUnit: row.materialUnit
          };
        } else {
          return;
        }
      }
      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName || '',
        materialReqProductVOS: productAndMaterialGroup
      };
      console.log(this.$cloneDeep(param));
      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },
    chooseMateria ({ list, RowIndex }) {
      console.log({ list, RowIndex });
      if (RowIndex === 'all') {
        // let cx = 0;
        this.productList.forEach((pro, index) => {
          // let mate = list[index - cx];
          // if (pro.productCode === mate.productSalesCode) {
          //   pro.materialNumberId = mate.selected;
          //   // 兼容字段materialUnit为空的时候
          //   pro.materialUnit = mate.materialUnit || '';
          //   pro.softFlag = mate.softFlag || '';
          // }
          // if (pro.exclusiveMaterialNumber) {
          //   cx++;
          // }
          let mate = list.find(row => pro.productCode === row.productSalesCode);
          if (mate && !pro.isBorrow) {
            pro.materialNumberId = mate.selected;
            // 兼容字段materialUnit为空的时候
            pro.materialUnit = mate.materialUnit || '';
            pro.softFlag = mate.softFlag || '';
          }
        });
      } else {
        this.productList[RowIndex].materialNumberId = list[0].selected;
        this.productList[RowIndex].materialUnit = list[0].materialUnit;
        this.productList[RowIndex].softFlag = list[0].softFlag;
      }
    },
    clickBorrow (row, index) {
      if (row.isBorrow) {
        this.productList[index].freightProperty = '20';
      } else {
        this.productList[index].freightProperty = '';
      }
    },
    async Recalculation () {
      await this.$nextTick();
      this.productList.forEach((item) => {
        this.getOrderAmount(item);
      });
    }
  },
  mounted () {
    this.taxRateFn();
  },
  watch: {
    computePriceTotal (val) {
      this.form.contractSum = val;
    },
    productList (val) {
      this.Recalculation();
    },
    isTestProject () {
      this.Recalculation();
    },
    salesType () {
      this.Recalculation();
    },
    communicationOrderDiscount () {
      this.Recalculation();
    },
    contractId (val) {
    },
    'address.id': {
      handler (newVal) {
        this.form.receiptAddressId = newVal;
      }
    }
  },
  filter: {
    rounding (value) {
      return value.toFixed(2);
    }
  }
};
</script>
<style lang="scss" scoped>
  .productTable{
    .el-table__footer-wrapper tbody td{
      background: #fff;
    }
  }
  /* adress
-------------------------- */
  .adressBox{
    display: inline-block;
    .item{
      display: inline-block;
      margin-right: 6px;
    }
    .defTab{
      padding: 3px 10px;
      display: inline-block;
      background: #1b73ff;
      font-size: 12px;
      color: #fff;
      border-radius: 4px;
      margin-right: 15px;
    }
  }
  .table{
    background: #00ff00;
  }
</style>
<style lang="scss">
  .rj-page-card{
    .table{
      .el-table{
       .red-row {
          background:  #f0f9eb;
          }
        .cell{
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }
</style>
